"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Simple pub/sub implementation; see useStorage or useCookie for examples of
 * usage
 */
exports.default = () => {
    let subscriptions = {};
    let latestValues = {};
    const subscribe = (key, subscription) => {
        subscriptions[key] = subscriptions[key] || [];
        subscriptions[key].push(subscription);
    };
    const unsubscribe = (key, subscription) => {
        subscriptions[key].splice(subscriptions[key].indexOf(subscription), 1);
        if (!subscriptions[key].length) {
            delete subscriptions[key];
        }
    };
    const publish = (key, value) => {
        latestValues[key] = value;
        subscriptions[key] = subscriptions[key] || [];
        subscriptions[key].forEach(subscription => subscription(value));
    };
    const getCurrent = (key, defaultValue) => {
        if (!(key in latestValues)) {
            if (typeof defaultValue === 'function') {
                latestValues[key] = defaultValue();
            }
            else {
                latestValues[key] = defaultValue;
            }
        }
        return latestValues[key];
    };
    const reset = (prefix) => {
        if (prefix) {
            Object.keys(subscriptions).forEach(key => {
                if (key.startsWith(prefix)) {
                    delete subscriptions[key];
                }
            });
            Object.keys(latestValues).forEach(key => {
                if (key.startsWith(prefix)) {
                    delete latestValues[key];
                }
            });
        }
        else {
            subscriptions = {};
            latestValues = {};
        }
    };
    return {
        subscribe,
        unsubscribe,
        publish,
        getCurrent,
        reset,
    };
};
//# sourceMappingURL=pubsub.js.map